import React from 'react'
import BlogContainer from '../../components/BlogContainer'
import { NextSeo } from 'next-seo'
import { GetStaticProps, NextPage } from 'next'

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'
import { Posts } from '../../models/blog'

export const getStaticProps: GetStaticProps = async () => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BLOG_URL}/wp-json/wpr/v1/posts`
  ).then()

  const posts = await res.json()

  return {
    props: {
      posts: posts
    }
  }
}

interface Props {
  posts: Posts[]
}

export const index: NextPage<Props, any> = (props: Props) => {
  const { posts } = props

  return (
    <>
      <NextSeo
        title="Majordomo's Insights on Repair Prices & Home Inspections"
        description="Stay up-to-date with our blog on repair prices, estimates, and home inspections."
        canonical="https://majordomo.com/blog"
        openGraph={{
          url: 'https://majordomo.com/blog',
          title: "Majordomo's Insights on Repair Prices & Home Inspections",
          description:
            'Stay up-to-date with our blog on repair prices, estimates, and home inspections.'
        }}
      />
      <Header />

      <div className="px-0 container mx-auto container-blog">
        <BlogContainer categorySlug={'/'} posts={posts} />
      </div>
      <Footer />
    </>
  )
}
export default index
